module.exports = __webpack_public_path__ + "img/cv.c823e988.svg";